<c-container>
  <c-row class="mt-5">
    <c-col><h2>Active Causable draws</h2></c-col>
  </c-row>
  <app-choose-your-game
    (gameChosenEvent)="onGameChange($event)"
    [message]="'Choose a game in order to view its active draw'">
  </app-choose-your-game>
</c-container>

@if (uiState == uiStateForTemplate.ShowData && chosenGamesActiveDraw) {
  <c-container>
  @if (userHasAnyAdvancedGameSettingsPermissions) {
    <c-row class="mb-3">
      <c-col md="3" class="mb-3">
        <div cListGroup>
          <button cListGroupItem
                  data-testid="draw-info-tab"
                  (click)="currentScreenState = screenStateEnum.DrawInfo"
                  [active]="currentScreenState === screenStateEnum.DrawInfo">
            <div>
              <h5 class="mb-1">Draw Info</h5>
              <p>View reporting graphs and general draw details</p>
            </div>
          </button>
          <button cListGroupItem
                  data-testid="advanced-game-instance-settings-tab"
                  (click)="currentScreenState = screenStateEnum.AdvancedGameInstanceSettings"
                  [active]="currentScreenState === screenStateEnum.AdvancedGameInstanceSettings">
            <div>
              <h5 class="mb-1">Advanced Game Instance Settings</h5>
              <p>Click here to view and enact advanced updates you can perform on the draw</p>
            </div>
          </button>
        </div>
      </c-col>
      <c-col>
        @switch (currentScreenState) {
          @case (screenStateEnum.DrawInfo) {
            <mat-card class="padding-large">
            <h2 data-testid="active-game-title">Current {{ chosenGame?.Name }} Draw</h2>

            <div class="flex-row-wrap gap-normal justify-space-between">
              <div class="full-width">
                <app-display-active-game-instance
                  [setSelectedGameInstance]="chosenGamesActiveDraw"></app-display-active-game-instance>
              </div>
            </div>
            </mat-card>
          }
          @case (screenStateEnum.AdvancedGameInstanceSettings) {
            <div cListGroup>
            <button cListGroupItem
                    *hasPermission="permissionTypes.ModifyGameSettings"
                    (click)="openEndGameInstance()"
                    data-testid="end-game-instance-button"
                    class="full-width">
              <div>
                <h5>Update Draw date and time</h5>
                <p>Update the current game instance's draw date and time</p>
              </div>
            </button>
            <button cListGroupItem
                    *hasPermission="permissionTypes.SendEmailBlast"
                    (click)="openEmailBlast()"
                    data-testid="send-message-to-all-users"
                    class="full-width">
              <div>
                <h5>Send Message to All Users</h5>
                <p>Create a custom email to be sent to all users or a select group of users in this game</p>
              </div>
            </button>
            </div>
          }
        }
      </c-col>
    </c-row>
  } @else {
    <c-row class="mb-4">
      <c-col>
        <div class="banner-label">Next Draw</div>
        <div class="banner-value" data-testid="game-banner-next-draw">{{ endDateCountDown$ | async }}</div>
      </c-col>
      <c-col>
        <div class="float-right">
          <div class="banner-label">Current Pot</div>
          <div class="banner-value"
               data-testid="game-banner-current-pot">{{ chosenGamesActiveDraw.PotTotal | formatCurrency }}
          </div>
        </div>

      </c-col>
    </c-row>
    <c-row></c-row>

  <c-container>
    <c-row>
      <c-col>
        <h2 data-testid="active-game-title">Current {{ chosenGame?.Name }} Draw</h2>

        <div class="flex-row-wrap gap-normal justify-space-between">
          <div class="full-width">
            <app-display-active-game-instance
              [setSelectedGameInstance]="chosenGamesActiveDraw"></app-display-active-game-instance>
          </div>
        </div>
      </c-col>
    </c-row>
  </c-container>
  }
  </c-container>
}
